module.exports = __webpack_public_path__ + "img/dialog-save-as-new.797e484f.png";